// extracted by mini-css-extract-plugin
export default {"fullFrame":"styles_fullFrame__G17fR","topFrame":"styles_topFrame__zMktW","halfFrame":"styles_halfFrame__iOxOJ","title":"styles_title__wza88"};